module.exports = __webpack_public_path__ + "img/view.5e5e22cb.svg";